if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        console.log('Testando');
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    },
  );
}

document.addEventListener('DOMContentLoaded', function () {
  console.log('DOMContentLoaded - Iniciando script...');

  const mediaGallery = document.querySelector('media-gallery');
  console.log('Media Gallery encontrada:', mediaGallery ? 'Sim' : 'Não');
  if (!mediaGallery) return;

  const galleryId = mediaGallery.id.split('-').pop();
  console.log('ID da galeria encontrado:', galleryId || 'Nenhum ID encontrado');
  const sliderComponent = document.getElementById(`GalleryViewer-template--${galleryId}`);
  console.log('Slider Component encontrado:', sliderComponent ? 'Sim' : 'Não');
  if (!sliderComponent) return;

  const navigateSlider = (direction) => {
    console.log(`Navegação solicitada: ${direction}`);

    const activeSlide = sliderComponent.querySelector('.slider__slide.is-active');
    console.log('Slide ativo encontrado:', activeSlide ? 'Sim' : 'Não');

    const allSlides = Array.from(sliderComponent.querySelectorAll('.slider__slide'));
    console.log('Total de slides encontrados:', allSlides.length);

    const currentIndex = allSlides.findIndex((slide) => slide === activeSlide);
    console.log('Índice atual:', currentIndex);

    let newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
    console.log('Novo índice calculado:', newIndex);

    // Ajuste de índice
    console.log(allSlides);
    newIndex = newIndex >= allSlides.length ? 0 : newIndex;
    newIndex = newIndex < 0 ? allSlides.length - 1 : newIndex;
    console.log('Índice após ajuste:', newIndex);

    const targetSlide = allSlides[newIndex];
    const targetMediaId = targetSlide?.dataset?.mediaId;
    console.log('ID da mídia alvo:', targetMediaId || 'Nenhum ID encontrado');

    if (targetMediaId) {
      console.log('Atualizando slides...');
      allSlides.forEach((slide) => slide.classList.remove('is-active'));
      targetSlide.classList.add('is-active');

      console.log('Ativando mídia na galeria...');
      mediaGallery.setActiveMedia(targetMediaId);

      const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
      console.log('Contador encontrado:', counterCurrent ? 'Sim' : 'Não');
      if (counterCurrent) {
        console.log('Atualizando contador...');
        counterCurrent.textContent = newIndex + 1;
      }
    }
  };

  console.log('Configurando botões...');
  const prevButton = sliderComponent.querySelector('.slider-button--prev');
  const nextButton = sliderComponent.querySelector('.slider-button--next');
  console.log('Botões encontrados:', {
    prev: !!prevButton,
    next: !!nextButton,
  });

  [prevButton, nextButton].forEach((button) => {
    if (button) {
      console.log(
        `Adicionando listener ao botão ${button.classList.contains('slider-button--prev') ? 'prev' : 'next'}`,
      );
      button.addEventListener('click', (e) => {
        e.preventDefault();
        console.log(`Botão ${button.classList.contains('slider-button--prev') ? 'prev' : 'next'} clicado`);
        navigateSlider(button.classList.contains('slider-button--prev') ? 'prev' : 'next');
      });
    }
  });

  console.log('Configurando touch gestures...');
  let touchStartX = 0;
  sliderComponent.addEventListener(
    'touchstart',
    (e) => {
      touchStartX = e.touches[0].clientX;
      console.log(`Touch start em: ${touchStartX}`);
    },
    { passive: true },
  );

  sliderComponent.addEventListener(
    'touchend',
    (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      console.log(`Touch end em: ${touchEndX}`);
      const diff = touchStartX - touchEndX;
      console.log(`Diferença de toque: ${diff}px`);

      if (Math.abs(diff) > 50) {
        console.log(`Swipe detectado (${diff > 0 ? 'esquerda' : 'direita'})`);
        navigateSlider(diff > 0 ? 'next' : 'prev');
      }
    },
    { passive: true },
  );
});
